import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {MatchOverviewComponent} from './pages/match-overview/match-overview.component';
import {MatchTickerComponent} from './pages/match-ticker/match-ticker.component';
import { MatchRoutePaths } from './match-route-paths';
import {MatchContainerComponent} from '@lib-modules/match/pages/match/match-container/match-container.component';

export const routes: Routes = [
  {
    path: '',
    component: MatchContainerComponent,
    children: [
      {
        path: '',
        redirectTo: MatchRoutePaths.Ticker,
        pathMatch: 'full'
      },
      {
        path: MatchRoutePaths.Infos,
        component: MatchOverviewComponent,
        data: { utmMedium: 'match-overview', utmContentParam: 'eventId' }
      },
      {
        path: MatchRoutePaths.Ticker,
        component: MatchTickerComponent,
        data: { utmMedium: 'match-ticker', utmContentParam: 'eventId' }
      },
      {
        path: MatchRoutePaths.Videos,
        component: MatchTickerComponent,
        data: { utmMedium: 'match-ticker', utmContentParam: 'eventId', onlyVideos: true }
      },
      {
        path: MatchRoutePaths.Lineup,
        loadChildren: () =>
          import('./modules/match-lineup/match-lineup.module').then(
            (m) => m.LibMatchLineupModule
          ),
        data: { utmMedium: 'match-lineup', utmContentParam: 'eventId' }
      },
      {
        path: MatchRoutePaths.Overview,
        loadChildren: () =>
          import('./modules/match-activities/match-activities.module').then(
            (m) => m.LibMatchActivitiesModule
          ),
        data: { utmMedium: 'match-activities', utmContentParam: 'eventId' }
      },
      {
        path: MatchRoutePaths.Table,
        loadChildren: () =>
          import('./modules/match-table/match-table.module').then(
            (m) => m.LibMatchTableModule
          ),
        data: { utmMedium: 'match-table', utmContentParam: 'eventId' }
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LibMatchRouting {}
